import { render } from "./ControlPanel.vue?vue&type=template&id=05d66d3c&scoped=true&ts=true"
import script from "./ControlPanel.vue?vue&type=script&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&lang=ts"

import "./ControlPanel.vue?vue&type=style&index=0&id=05d66d3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d66d3c"]])

export default __exports__